export const columnColorSchemes = {
  style1: {
    column: {
      backgroundColor: 'rgb(255, 255, 255)',
      borderColor: 'rgba(0, 0, 0, 0.05)'
    },
    title: {
      backgroundColor: 'transparent'
    },
    features: {
      iconColor: 'primary'
    },
    button: {
      backgroundColor: 'primary',
      color: 'secondary'
    },
    highlight: {
      backgroundColor: 'primary',
      color: 'secondary'
    }
  },

  style2: {
    column: {
      backgroundColor: 'rgb(255, 255, 255)',
      borderColor: 'rgba(0, 0, 0, 0.05)'
    },
    title: {
      backgroundColor: 'primary'
    },
    features: {
      iconColor: 'primary'
    },
    button: {
      backgroundColor: 'primary',
      color: 'secondary'
    },
    highlight: {
      backgroundColor: 'primary',
      color: 'secondary'
    }
  },

  style3: {
    column: {
      backgroundColor: 'primary',
      borderColor: 'rgba(0, 0, 0, 0.05)'
    },
    title: {
      backgroundColor: 'transparent'
    },
    features: {
      iconColor: 'secondary'
    },
    button: {
      backgroundColor: 'secondary',
      color: 'primary'
    },
    highlight: {
      backgroundColor: 'secondary',
      color: 'primary'
    }
  },

  style4: {
    column: {
      backgroundColor: 'rgb(255, 255, 255)',
      borderColor: 'rgba(0, 0, 0, 0.05)'
    },
    title: {
      backgroundColor: 'transparent'
    },
    features: {
      iconColor: 'primary'
    },
    button: {
      backgroundColor: 'primary',
      color: 'secondary'
    },
    highlight: {
      backgroundColor: 'primary',
      color: 'secondary'
    }
  },

  style5: {
    column: {
      backgroundColor: 'rgb(255, 255, 255)',
      borderColor: 'rgba(0, 0, 0, 0.05)'
    },
    title: {
      backgroundColor: 'primary'
    },
    features: {
      iconColor: 'primary'
    },
    button: {
      backgroundColor: 'primary',
      color: 'secondary'
    },
    highlight: {
      backgroundColor: 'primary',
      color: 'secondary'
    }
  },

  style6: {
    column: {
      backgroundColor: 'primary',
      borderColor: 'rgba(0, 0, 0, 0.05)'
    },
    title: {
      backgroundColor: 'transparent'
    },
    features: {
      iconColor: 'secondary'
    },
    button: {
      backgroundColor: 'secondary',
      color: 'primary'
    },
    highlight: {
      backgroundColor: 'secondary',
      color: 'primary'
    }
  }
} as const;
